import { AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'app-modal-shell',
    templateUrl: './modal-shell.component.html',
    styleUrls: ['./modal-shell.component.scss'],
    standalone: false
})
export class ModalShellComponent implements AfterViewInit {
  @ViewChild('dialog') private dialog!: ElementRef<HTMLElement>;
  @Input() labelledBy?: string;
  @Input() accessibleLabel?: string;

  ngAfterViewInit(): void {
    const focusTarget = this.focusableElements()[0];
    (focusTarget ?? this.dialog.nativeElement).focus();
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Tab') return;
    const elements = this.focusableElements();
    const first = elements[0];
    const last = elements.at(-1);
    const active = this.dialog.nativeElement.ownerDocument.activeElement;
    if (!first) {
      event.preventDefault();
      this.dialog.nativeElement.focus();
    } else if (event.shiftKey && (active === first || active === this.dialog.nativeElement)) {
      event.preventDefault();
      last!.focus();
    } else if (!event.shiftKey && (active === last || active === this.dialog.nativeElement)) {
      event.preventDefault();
      first.focus();
    }
  }

  private focusableElements(): HTMLElement[] {
    return Array.from(this.dialog.nativeElement.querySelectorAll<HTMLElement>(
      'button, [href], input, select, textarea, [tabindex]'
    )).filter(element => !element.matches(':disabled, [hidden], [inert], [tabindex="-1"]')
      && element.getClientRects().length > 0);
  }

}
